export const ATTENDANCE_ACTION_TYPES = {
  LOAD_TODAY_REQUEST: "ATTENDANCE_LOAD_TODAY_REQUEST",
  LOAD_TODAY_SUCCESS: "ATTENDANCE_LOAD_TODAY_SUCCESS",
  LOAD_TODAY_FAILURE: "ATTENDANCE_LOAD_TODAY_FAILURE",
  SET_TODAY_ACTIVITY: "ATTENDANCE_SET_TODAY_ACTIVITY",
};
